package com.daytimegaming.ourdailyfinances.domain.realestate

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

class RealEstateEventBus {
    private val _events = MutableSharedFlow<Unit>(extraBufferCapacity = 1)
    val events = _events.asSharedFlow()

    suspend fun emitEvent() {
        _events.emit(Unit)
    }
}
